// Modules
import React, { ReactElement, useState } from 'react';
import { useSelector } from 'react-redux';

// Styled Components
import * as EVENT from './event-content-left-col.styles';

// Types
import { Event } from '../../types/events';

import CalendarIcon from '../../assets/event-calendar.svg';
import LocationIcon from '../../assets/event-location.svg';
import PriceIcon from '../../assets/event-price.svg';
import TypeIcon from '../../assets/event-type.svg';
import TimeIcon from '../../assets/event-time.svg';
import AudienceIcon from '../../assets/event-audience.svg';

import { capitalizedLang } from '../../selectors/common.selector';

// Constants
import { constant } from '../../constants/contant';
import EventCheckout from '../event-checkout/event-checkout.component';
import EventContact from '../event-contact/event-contact.component';
import AddToCalendar from '../add-to-calendar/add-to-calendar.component';
import AdditionalInfo from '../additional-info/additional-info.component';

const EventContentLeftCol = ({ event }: { event: Event }): ReactElement => {
	const [hover, setHover] = useState(false);
	// Dispatcher
	const dir = useSelector((state: any) => state.common.dir);
	const lang = useSelector((state: any) => capitalizedLang()(state));

	const getIcon = (name: string) => {
		switch (name) {
			case 'calendar':
				return CalendarIcon;
			case 'location':
				return LocationIcon;
			case 'price':
				return PriceIcon;
			case 'type':
				return TypeIcon;
			case 'time':
				return TimeIcon;
			case 'audience':
				return AudienceIcon;
		}
	};
	// Render
	return (
		<>
			<EVENT.Fields>
				{event.eventFields(lang).map((field, index) => {
					
					if (field.value)
						return (
							<EVENT.Field key={index}>
								<EVENT.FieldIcon
									lg={field.icon === 'location'}
									src={getIcon(field.icon)}
									alt=""
								/>
								<EVENT.FieldLabelText>
									{constant[lang].VARIABLES[field.lable]}
								</EVENT.FieldLabelText>
								{field.type === 'text' && <EVENT.P>{field.value}</EVENT.P>}
								{field.type === 'link' && (
									<EVENT.Link href={field.value}>
										{constant[lang].VARIABLES.ENTER_EVENT}
									</EVENT.Link>
								)}
							</EVENT.Field>
						);
				})}
				<EVENT.AdditionalInfo>
					<AdditionalInfo event={event} dir={dir} lang={lang}/>
				</EVENT.AdditionalInfo>
			</EVENT.Fields>
		</>
	);
};

export default EventContentLeftCol;
